export default __webpack_public_path__ + "static/media/dewali.c876b580.png";